import { render, staticRenderFns } from "./DlTravelClmGIA.vue?vue&type=template&id=1a4ab3fc&"
import script from "./DlTravelClmGIA.vue?vue&type=script&lang=js&"
export * from "./DlTravelClmGIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports